import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledTextWithBadges from "@coworker/apprestructured/src/task-management/components/TitledTextWithBadges/TitledTextWithBadges";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function TitledTextWithBadgesDemo() {
  const [title, setTitle] = useState("Title");
  const [text, setText] = useState("Some text");
  const [nbrOfBadges, setNbrOfBadges] = useState(4);
  const [badgeText, setBadgeText] = useState("Badge");

  const badges = Array.from(
    { length: nbrOfBadges },
    (_, i) => `${badgeText} ${i + 1}`
  );

  return (
    <Demo>
      <Name>TitledTextWithBadgesDemo</Name>
      <Highlight>
        <TitledTextWithBadges title={title} text={text} badges={badges} />
      </Highlight>
      <Actions>
        <FixaInputField
          label="title"
          type="text"
          id="titledtextwithbadgesdemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          label="text"
          type="text"
          id="titledtextwithbadgesdemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <FixaInputField
          label="nbrOfBadges"
          type="number"
          id="titledtextwithbadgesdemo-nbrofbadges"
          value={nbrOfBadges.toString()}
          onChange={(e) => setNbrOfBadges(Number(e.target.value))}
        />
        <FixaInputField
          label="badgeText"
          type="text"
          id="titledtextwithbadgesdemo-badgetext"
          value={badgeText}
          onChange={(e) => setBadgeText(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(TitledTextWithBadgesDemo);
